export default __webpack_public_path__ + "static/media/eye.c449b1e6.svg";